import React from "react";
import { PresenceTransition } from "native-base";

export const AnimationFactory = ({ initial, animate }) => {
    return class Animation extends React.PureComponent {
        render() {
            return (
                <PresenceTransition
                    visible={this.props.in}
                    initial={initial}
                    animate={animate}
                >{ this.props.children }</PresenceTransition>
            )
        }
    }
}